import React from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { Link } from "react-router-dom";
import nophoto from "../../img/nophoto.jpg";

const BlogCard = ({ blog }) => {
  const { id, title, cover, publishedAt, content, excerpt } = blog;
  const tmp = blog.attributes;
  const { t } = useTranslation();
  return (
    <>
      <Link to={`/blogs/${id}`}>
        <div className="overflow-hidden shadow-lg rounded-lg max-h-90 cursor-pointer m-auto relative mt-10 mb-10">
          <img
            alt="blog photo"
            src={
              tmp.cover.data.attributes === null
                ? nophoto
                : tmp.cover.data.attributes.formats.small
                ? `${process.env.RAZZLE_STRAPI_URL}${tmp.cover.data.attributes.formats.small.url}`
                : `${process.env.RAZZLE_STRAPI_URL}${tmp.cover.data.attributes.formats.thumbnail.url}`
            }
            className="rounded-t-lg max-h-40 w-full object-cover"
          />
          <div className="bg-white dark:bg-gray-800 w-full p-4 relative">
            <p className="text-gray-800 dark:text-white text-xl font-medium mb-2">
              {tmp.title}
            </p>
            <div className="text-pink text-base mt-3 mb-5">
              {moment(publishedAt).format("DD.MM.YYYY")}
            </div>
            <p className="text-gray-400 dark:text-gray-300 font-light text-md">
              {tmp.excerpt}
            </p>
            <div className="flex items-center mt-10">
              <Link to={`/blogs/${id}`}>
                <div className="font-bold text-blue">{t("read_more")}</div>
              </Link>
            </div>
          </div>
        </div>
      </Link>
    </>
  );
};
export default BlogCard;
